export class EntTypeProductFilter {
  page: number = 1;
  size: number = 30;
  name: string | null = null;                
  unitMeasurementId: number | null = null;        
  directionId: number | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
  deleted: boolean = false;               
}
